/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface CioSortDropdownArgs {
  disabled: boolean;
  sortDirectionDisabled: boolean;
  items: Record<string, any>[];
  selected: string;
  sortDescending: boolean;
  showLabel: boolean;
  onChange: () => unknown;
  onSetSortDescending: (sortDescending: boolean) => unknown;
}

export default class CioSortDropdown extends Component<CioSortDropdownArgs> {
  get showLabel() {
    return this.args.showLabel ?? true;
  }

  get sortDescending() {
    return this.args.sortDescending ?? true;
  }

  @action
  onSetSortDescending(value: boolean) {
    this.args.onSetSortDescending(value);
  }
}
